/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_X_Offset_LabelInputs */

const en_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontal (X) Offset`)
};

const fr_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decalage horizontal (X)`)
};

const de_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontaler (X) Versatz`)
};

const it_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset orizzontale (X)`)
};

const ru_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Горизонтальное (X) смещение`)
};

const es_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento horizontal (X)`)
};

const zh_cn2_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平 (X) 偏移`)
};

const ja_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平（X）オフセット`)
};

const hi_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षैतिज (X) ऑफ़सेट`)
};

const pt_pt2_style_guide_manager_position_x_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento horizontal (X)`)
};

/**
* | output |
* | --- |
* | "Horizontal (X) Offset" |
*
* @param {Style_Guide_Manager_Position_X_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_x_offset_label = /** @type {((inputs?: Style_Guide_Manager_Position_X_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_X_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_x_offset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_x_offset_label(inputs)
	return en_style_guide_manager_position_x_offset_label(inputs)
});